import { useState } from "react"
import PropTypes from "prop-types"
import { Badge, IconButton } from "@mui/material"
import { SwapHoriz } from "@mui/icons-material"
import classNames from "classnames"
import { useTrack } from "helpers/analytics"
import Tooltip from "components/material/tooltip"

import "./style.scss"

export default function TradesButton({ toggleTrades, numberOfTrades }) {
  const [touched, setTouched] = useState(false)

  const trackToggleTrades = useTrack({
    type: "simulator-toggle-trades",
  })
  return <Tooltip title="Trades" classes={{ popper: "rebalance-option" }}>
    <div>
      <Badge
        className={classNames("rebalance-trades-badge", { grow: numberOfTrades > 0 && !touched })}
        badgeContent={numberOfTrades}
        color="primary"
        overlap="rectangular"
      >
        <IconButton
          className="rebalance-trades-button"
          onClick={(...args) => {
            setTouched(true)
            trackToggleTrades()
            toggleTrades(...args)
          }}
          disabled={numberOfTrades === 0}
          size="large"
        >
          <SwapHoriz />
        </IconButton>
      </Badge>
    </div>
  </Tooltip>
}

TradesButton.propTypes = {
  toggleTrades: PropTypes.func.isRequired,
  numberOfTrades: PropTypes.number.isRequired,
}
